import { IStatus } from '@dfl/mui-react-common';
import { BLUE, GREEN, RED, WARNING } from 'settings/theme';
import { disabledIncidenceStatusToRefound, disabledIncidenceStatusCompleted } from 'utils/flags-utils';

export enum INCIDENCE_STATUS_ENUM {
  OPEN = 'OPEN',
  IN_REVIEW = 'IN_REVIEW',
  RESOLVED = 'RESOLVED',
  TO_REFOUND = 'TO_REFOUND',
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED',
}

const ALL_INCIDENCE_STATUS: IStatus[] = [
  { _id: INCIDENCE_STATUS_ENUM.OPEN, title: 'status.OPEN', color: WARNING },
  { _id: INCIDENCE_STATUS_ENUM.IN_REVIEW, title: 'status.IN_REVIEW', color: BLUE },
  { _id: INCIDENCE_STATUS_ENUM.RESOLVED, title: 'status.RESOLVED', color: GREEN },
  { _id: INCIDENCE_STATUS_ENUM.TO_REFOUND, title: 'status.TO_REFOUND', color: WARNING },
  { _id: INCIDENCE_STATUS_ENUM.COMPLETED, title: 'status.COMPLETED', color: GREEN },
  { _id: INCIDENCE_STATUS_ENUM.CLOSED, title: 'status.CLOSED', color: RED },
];

export const INCIDENCE_STATUS: IStatus[] = ALL_INCIDENCE_STATUS.filter((status) => {
  if (disabledIncidenceStatusToRefound && status._id === INCIDENCE_STATUS_ENUM.TO_REFOUND) return false;
  if (disabledIncidenceStatusCompleted && status._id === INCIDENCE_STATUS_ENUM.COMPLETED) return false;
  return true;
});

export const INCIDENCE_STATUS_MAP = new Map<string, IStatus>(
  ALL_INCIDENCE_STATUS.map((status) => [status._id, status])
);
